/* istanbul ignore file */
import Error from './Error';

export default Error;
